

## Allenamento per la Fase II - Scuole secondarie

Questa prova contiene _6 domande_ da risolvere in _100 minuti_.
Le domande sono a **scelta multipla** o a **blocchi**, e sono divise in due parti:

- domande di interpretazione di **procedimenti procedurali** come programmi a blocchi, e
- domande di **programmazione** tramite blocchi.

In entrambe le parti, le domande sono ordinate per difficoltà crescente.
**Attento che la difficoltà è soggettiva!** Se stai passando tanto tempo cercando di risolvere una domanda, prova a passare ad altre domande e altre categorie!

## Punteggio

Tutte le domande a _scelta multipla_ hanno 5 opzioni, di cui **solo una** è corretta. Il punteggio che puoi ottenere è:

- 5 punti per una risposta _corretta_;
- 1 punto per una risposta _non data_;
- 0 punti per una risposta _sbagliata_.

Le domande a _blocchi_ richiedono di scrivere un singolo programma a blocchi, che viene valutato su tre diversi livelli.
Per ciascuna domanda e per ciascun livello, Il punteggio che puoi ottenere è:

- 5 punti se il programma produce la risposta _corretta_;
- 0 punti se il programma produce una risposta _sbagliata_.

Quindi ogni domanda a blocchi può valere fino a 15 punti in totale.
